<template>
  <div class="sending-domains">
    <ul class="nav nav-tabs pt-3 mb-3">
      <li class="nav-item">
        <a
          href="javascript:;"
          class="nav-link"
          :class="{ active: activeTab === 'whitelist' }"
          @click="activeTab = 'whitelist'"
          >Whitelist</a
        >
      </li>
      <li class="nav-item">
        <a
          href="javascript:;"
          class="nav-link"
          :class="{ active: activeTab === 'banned' }"
          @click="activeTab = 'banned'"
          >Ban list</a
        >
      </li>
    </ul>

    <div v-show="activeTab === 'whitelist'">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Whitelisted sending domains</h1>
      </div>

      <p class="text-muted">
        Whitelisted sending domains won't trip our automated abuse detection.
      </p>

      <form @submit.prevent="addWhitelisted">
        <div class="input-group mb-3">
          <input
            type="text"
            placeholder="domain.tld"
            class="form-control"
            v-model="whitelistDomain"
          />
          <input
            type="text"
            placeholder="Reason"
            class="form-control"
            v-model="whitelistReason"
          />
          <div class="input-group-append">
            <input
              type="submit"
              name="whitelist"
              value="Whitelist Domain"
              class="btn btn-sm btn-success"
            />
          </div>
        </div>
      </form>

      <div class="form-row mb-3">
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            placeholder="Search by domain…"
            v-model="whitelistSearch"
          />
        </div>
      </div>

      <table
        v-if="filteredWhitelisted.length"
        class="table table-striped table-hover"
      >
        <thead>
          <tr>
            <th>Domain</th>
            <th>Reason</th>
            <th>Whitelisted by</th>
            <th>Created at (UTC)</th>
            <th class="text-right">Remove</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedWhitelisted" v-bind:key="item.domain">
            <td>{{ item.domain }}</td>
            <td>{{ item.reason }}</td>
            <td>{{ item.whitelisted_by }}</td>
            <td>{{ item.created_at }}</td>
            <td class="text-right">
              <a
                href="javascript:;"
                title="Remove from whitelist"
                class="btn btn-danger"
                v-on:click="removeWhitelisted(item.domain)"
                >Remove</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="alert alert-primary" role="alert">
        {{
          whitelistSearch
            ? "No domains match your search."
            : "No whitelisted sending domains yet."
        }}
      </div>

      <div
        v-if="whitelistPageCount > 1"
        class="d-flex justify-content-between align-items-center mt-4 pt-3 mb-5 border-top"
      >
        <span class="text-muted">
          Showing {{ (whitelistPage - 1) * pageSize + 1 }}–{{
            Math.min(whitelistPage * pageSize, filteredWhitelisted.length)
          }}
          of {{ filteredWhitelisted.length }}
        </span>
        <div>
          <button
            class="btn btn-sm btn-primary mr-2"
            :disabled="whitelistPage === 1"
            @click="whitelistPage--"
          >
            Previous
          </button>
          <button
            class="btn btn-sm btn-primary"
            :disabled="whitelistPage >= whitelistPageCount"
            @click="whitelistPage++"
          >
            Next
          </button>
        </div>
      </div>
    </div>

    <div v-show="activeTab === 'banned'">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Banned sending domains</h1>
      </div>

      <p class="text-muted">
        Banned sending domains will not pass aws-smtp for sending.
      </p>

      <form @submit.prevent="addBanned" class="mb-3">
        <div class="form-row align-items-end">
          <div class="col-4">
            <label class="mb-1">Domain</label>
            <input
              type="text"
              placeholder="domain.tld"
              class="form-control"
              v-model="banDomain"
            />
          </div>
          <div class="col">
            <label class="mb-1">Reason</label>
            <input
              type="text"
              placeholder="Reason"
              class="form-control"
              v-model="banReason"
            />
          </div>
          <div class="col">
            <label class="mb-1"
              >Expires at (UTC, optional, YYYY-MM-DD HH:MM:SS)</label
            >
            <input
              type="text"
              placeholder="YYYY-MM-DD HH:MM:SS"
              class="form-control"
              v-model="banExpiresAt"
            />
          </div>
          <div class="col-auto">
            <input
              type="submit"
              name="ban"
              value="Ban Domain"
              class="btn btn-sm btn-warning"
            />
          </div>
        </div>
      </form>

      <div class="form-row mb-3">
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            placeholder="Search by domain…"
            v-model="banSearch"
          />
        </div>
      </div>

      <table
        v-if="filteredBanned.length"
        class="table table-striped table-hover"
      >
        <thead>
          <tr>
            <th>Domain</th>
            <th>Reason</th>
            <th>Banned by</th>
            <th>Created at (UTC)</th>
            <th>Expires at (UTC)</th>
            <th class="text-right">Remove</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedBanned" v-bind:key="item.domain">
            <td>{{ item.domain }}</td>
            <td>{{ item.reason }}</td>
            <td>{{ item.banned_by }}</td>
            <td>{{ item.created_at }}</td>
            <td>{{ item.expires_at || "Never" }}</td>
            <td class="text-right">
              <a
                href="javascript:;"
                title="Remove from ban list"
                class="btn btn-danger"
                v-on:click="removeBanned(item.domain)"
                >Remove</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="alert alert-primary" role="alert">
        {{
          banSearch
            ? "No domains match your search."
            : "No banned sending domains yet."
        }}
      </div>

      <div
        v-if="banPageCount > 1"
        class="d-flex justify-content-between align-items-center mt-4 pt-3 mb-5 border-top"
      >
        <span class="text-muted">
          Showing {{ (banPage - 1) * pageSize + 1 }}–{{
            Math.min(banPage * pageSize, filteredBanned.length)
          }}
          of {{ filteredBanned.length }}
        </span>
        <div>
          <button
            class="btn btn-sm btn-primary mr-2"
            :disabled="banPage === 1"
            @click="banPage--"
          >
            Previous
          </button>
          <button
            class="btn btn-sm btn-primary"
            :disabled="banPage >= banPageCount"
            @click="banPage++"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatHttpError } from "../utils/errors";

export default {
  data() {
    return {
      activeTab: "whitelist",
      whitelisted: [],
      banned: [],
      whitelistDomain: null,
      whitelistReason: null,
      banDomain: null,
      banReason: null,
      banExpiresAt: null,
      whitelistSearch: "",
      banSearch: "",
      whitelistPage: 1,
      banPage: 1,
      pageSize: 40,
    };
  },
  created() {
    if (this.$route.query.ban === "true") this.activeTab = "banned";
    this.loadWhitelisted();
    this.loadBanned();
    this.autoBanFromQuery();
    this.autoWhitelistFromQuery();
  },
  computed: {
    filteredWhitelisted() {
      const query = this.whitelistSearch.trim().toLowerCase();
      if (!query) return this.whitelisted;
      return this.whitelisted.filter((item) =>
        item.domain.toLowerCase().includes(query),
      );
    },
    paginatedWhitelisted() {
      const start = (this.whitelistPage - 1) * this.pageSize;
      return this.filteredWhitelisted.slice(start, start + this.pageSize);
    },
    whitelistPageCount() {
      return Math.ceil(this.filteredWhitelisted.length / this.pageSize);
    },
    // Bans with an expiry float to the top, soonest-expiring first; permanent bans (no expires_at) follow.
    filteredBanned() {
      const query = this.banSearch.trim().toLowerCase();
      const matches = query
        ? this.banned.filter((item) =>
            item.domain.toLowerCase().includes(query),
          )
        : this.banned;
      return [...matches].sort((a, b) => {
        if (a.expires_at && b.expires_at) {
          return new Date(a.expires_at) - new Date(b.expires_at);
        }
        if (a.expires_at) return -1;
        if (b.expires_at) return 1;
        return 0;
      });
    },
    paginatedBanned() {
      const start = (this.banPage - 1) * this.pageSize;
      return this.filteredBanned.slice(start, start + this.pageSize);
    },
    banPageCount() {
      return Math.ceil(this.filteredBanned.length / this.pageSize);
    },
  },
  watch: {
    whitelistSearch() {
      this.whitelistPage = 1;
    },
    banSearch() {
      this.banPage = 1;
    },
  },
  methods: {
    // Lets Slack abuse alerts link straight to a one-click ban, e.g.
    // /sending-domains?ban=true&domain=asdf.com&reason=Spam%20campaign
    autoBanFromQuery() {
      const { ban, domain, reason } = this.$route.query;
      if (ban !== "true" || !domain) return;
      this.banDomain = domain;
      this.banReason = reason || "";
      this.addBanned(() => {
        alert(
          `domain: ${this.cleanDomain(domain)} banned for reason: ${reason}`,
        );
      });
    },
    // Lets Slack abuse alerts link straight to a one-click whitelist, e.g.
    // /sending-domains?whitelist=true&domain=asdf.com&reason=False%20positive
    autoWhitelistFromQuery() {
      const { whitelist, domain, reason } = this.$route.query;
      if (whitelist !== "true" || !domain) return;
      this.whitelistDomain = domain;
      this.whitelistReason = reason || "";
      this.addWhitelisted(() => {
        alert(
          `domain: ${this.cleanDomain(
            domain,
          )} whitelisted for reason: ${reason}`,
        );
      });
    },
    cleanDomain(domain) {
      return domain
        .trim()
        .replace("http://", "")
        .replace("https://", "")
        .replace("/", "");
    },
    loadWhitelisted() {
      this.$http.get("whitelisted-sending-domains").then(
        (response) => {
          this.whitelisted = response.body.items;
        },
        (response) => {
          if (response.status === 401) return;
          alert(formatHttpError(response));
        },
      );
    },
    loadBanned() {
      this.$http.get("banned-sending-domains").then(
        (response) => {
          this.banned = response.body.items;
        },
        (response) => {
          if (response.status === 401) return;
          alert(formatHttpError(response));
        },
      );
    },
    addWhitelisted(onSuccess) {
      const domain = this.cleanDomain(this.whitelistDomain || "");
      const reason = (this.whitelistReason || "").trim();
      if (!domain || !reason) {
        return alert("Domain and reason are required.");
      }
      this.$http.post("whitelisted-sending-domains", { domain, reason }).then(
        (response) => {
          this.whitelisted.unshift(response.body);
          this.whitelistDomain = null;
          this.whitelistReason = null;
          if (onSuccess) onSuccess();
        },
        (response) => {
          if (response.status === 401) return;
          alert(formatHttpError(response));
        },
      );
    },
    addBanned(onSuccess) {
      const domain = this.cleanDomain(this.banDomain || "");
      const reason = (this.banReason || "").trim();
      if (!domain || !reason) {
        return alert("Domain and reason are required.");
      }
      const payload = { domain, reason };
      const expiresAt = (this.banExpiresAt || "").trim();
      if (expiresAt) payload.expires_at = expiresAt;
      this.$http.post("banned-sending-domains", payload).then(
        (response) => {
          this.banned.unshift(response.body);
          this.banDomain = null;
          this.banReason = null;
          this.banExpiresAt = null;
          if (onSuccess) onSuccess();
        },
        (response) => {
          if (response.status === 401) return;
          alert(formatHttpError(response));
        },
      );
    },
    removeWhitelisted(domain) {
      if (!confirm(`Remove ${domain} from the whitelist?`)) return;
      this.$http.delete(`whitelisted-sending-domains/${domain}`).then(
        () => {
          const idx = this.whitelisted.findIndex((x) => x.domain === domain);
          this.whitelisted.splice(idx, 1);
        },
        (response) => {
          alert(formatHttpError(response));
        },
      );
    },
    removeBanned(domain) {
      if (!confirm(`Remove ${domain} from the ban list?`)) return;
      this.$http.delete(`banned-sending-domains/${domain}`).then(
        () => {
          const idx = this.banned.findIndex((x) => x.domain === domain);
          this.banned.splice(idx, 1);
        },
        (response) => {
          alert(formatHttpError(response));
        },
      );
    },
  },
};
</script>
